import { Box, Container, Paper, Typography } from '@mui/material'
import bg from '../../assets/images/photo.png'
import { benefits } from '../../data/landing'

export default function Benefits() {
  return (
    <Box id="benefits" sx={{ py: 10 }}>
      <Container maxWidth="lg">
        <Paper
          sx={{
            position: 'relative',
            overflow: 'hidden',
            p: { xs: 3, md: 5 },
            borderRadius: 5,
            background:
  'linear-gradient(135deg, rgba(99,102,241,0.18), rgba(255,255,255,0.04))',
            border: '1px solid rgba(255,255,255,0.08)',
            color: '#fff',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(135deg, rgba(0,0,0,0.78), rgba(0,0,0,0.48))',
              zIndex: 1,
            }}
          />

          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.6)' }}>
              Benefits
            </Typography>

            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2, mt: 1 }}>
              Why business owners love this model
            </Typography>

            <Typography
              sx={{
                color: 'rgba(255,255,255,0.82)',
                maxWidth: 760,
                lineHeight: 1.8,
                mb: 5,
              }}
            >
              Add a modern self-service experience to your location without investing
              in equipment, hiring extra staff, or creating more daily operational work.
            </Typography>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: '1fr 1fr',
                  md: '1fr 1fr 1fr',
                },
                gap: 3,
              }}
            >
              {benefits.map((item) => (
                <Paper
                  key={item}
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    background: 'rgba(10,10,10,0.42)',
                    backdropFilter: 'blur(8px)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    color: '#fff',
                    height: '100%',
                    transition: '0.3s ease',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                    '&:hover': {
                      transform: 'translateY(-6px)',
                      borderColor: 'rgba(255,255,255,0.2)',
                      boxShadow: '0 16px 40px rgba(0,0,0,0.35)',
                    },
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 10,
                        height: 10,
                        borderRadius: '50%',
                        bgcolor: '#4caf50',
                        mt: '8px',
                        flexShrink: 0,
                      }}
                    />
                    <Typography sx={{ lineHeight: 1.7, color: 'rgba(255,255,255,0.9)' }}>
                      {item}
                    </Typography>
                  </Box>
                </Paper>
              ))}
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}